import { ResourcesConfig } from 'aws-amplify';

export const getAuthConfig = ({
  redirectSignIn,
  redirectSignOut
}: {
  redirectSignIn: string[];
  redirectSignOut: string[];
}): ResourcesConfig => ({
  Auth: {
    Cognito: {
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
          providers: ['Google'],
          redirectSignIn,
          redirectSignOut,
          responseType: 'code' as 'code' | 'token',
          scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin']
        }
      },
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID
    }
  }
});
